export const MAX_DURATION = 2 * 60 * 60;
export const MAX_FILE_SIZE = 20 * 1024 * 1024 * 1024; // 20GB
export const VALID_MIME_TYPES = [
    'audio/mpeg',      // .mp3
    'video/mp4',       // .mp4
    'audio/mp4', 'audio/x-m4a',      // .m4a
    'video/quicktime', // .mov
    'audio/wav'        // .wav
];